/* tslint:disable */
/* eslint-disable */
/**
 * KDS API
 * Internal KDS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateKdsDevice200Response
 */
export interface UpdateKdsDevice200Response {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateKdsDevice200Response
     */
    ok: boolean;
}

/**
 * Check if a given object implements the UpdateKdsDevice200Response interface.
 */
export function instanceOfUpdateKdsDevice200Response(value: object): value is UpdateKdsDevice200Response {
    if (!('ok' in value) || value['ok'] === undefined) return false;
    return true;
}

export function UpdateKdsDevice200ResponseFromJSON(json: any): UpdateKdsDevice200Response {
    return UpdateKdsDevice200ResponseFromJSONTyped(json, false);
}

export function UpdateKdsDevice200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateKdsDevice200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'ok': json['ok'],
    };
}

export function UpdateKdsDevice200ResponseToJSON(json: any): UpdateKdsDevice200Response {
    return UpdateKdsDevice200ResponseToJSONTyped(json, false);
}

export function UpdateKdsDevice200ResponseToJSONTyped(value?: UpdateKdsDevice200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ok': value['ok'],
    };
}

